import {
  firestore,
  collection,
  getDocs,
  query,
  where
} from '../../utils/firestore'
import {
  collection as collectionLite,
  getDocs as getDocsLite,
  query as queryLite,
  where as whereLite,
  firestoreLite
} from '../../utils/firestoreLite'
import {
  metricsCollectionName,
  dataEntryUser,
  verificationUser
} from '../common/appConstants'
import { defaultSelect } from '../../irmlib/src/common'

export const districtMetricsInfo = async(district, startDate, endDate) => {
  const metricsinfo = getDocsLite(queryLite(collectionLite(firestoreLite, metricsCollectionName), 
    whereLite('districtId', '==', district), whereLite('activityType', '==', 'keystroke'),
    whereLite('createdTs', '>=', startDate), 
    whereLite('createdTs', '<=', endDate)))
  return metricsinfo
}

// export const districtMetricsInfo1 = async(district, startDate, endDate) => {
//   const metricsinfo = getDocs(query(collection(firestore, metricsCollectionName), 
//     where('districtId', '==', district), where('activityType', '==', 'keystroke'),
//     where('createdTs', '>=', startDate), 
//     where('createdTs', '<=', endDate)))
//   return metricsinfo
// }

export const districtMetricsInfoByWorker = async (district, workerId, startDate, endDate) => {
  const metricsinfo = getDocs(query(collection(firestore, metricsCollectionName), 
    where('districtId', '==', district), where('activityType', '==', 'keystroke'),
    where('workerId', '==', workerId), 
    where('createdTs', '>=', startDate), where('createdTs', '<=', endDate)))
  return metricsinfo
}

export const getSessionTime = (filters) => {
  const { allUsers: workerId, country, districtId } = filters
  const defaultEmployeeSelection = 'all-employees'
  let { startDate, endDate } = filters
  const args = []
  let arrIndex = 0
  args[arrIndex] = collection(firestore, metricsCollectionName)
 
  //  get session time alone
  args[++arrIndex] = where('activityType', '==', 'login')

  // filter by workers / employee
  if (workerId && workerId !== defaultEmployeeSelection) {
    args[++arrIndex] = where('workerId', '==', workerId)
  }
  
  // filter by country
  if (country && country !== defaultSelect) {
    args[++arrIndex] = where('workerCountry', '==', country)
  }

  // filter by date
  if (startDate) {
    // setting start time of the date.
    startDate = new Date(`${startDate} 00:00:00`)
    args[++arrIndex] = where('loggedInTs', '>=', startDate)
  } 

  if (endDate) {
    // setting last time of the date.
    endDate = new Date(`${endDate} 23:59:59`)
    args[++arrIndex] = where('loggedInTs', '<=', endDate)
  }

  // filter by districts
  if (districtId?.length > 0) {
    args[++arrIndex] = where('districtId', 'in', districtId)
  }
    
  const queries = query.apply(null, args)
  const queryResult = getDocs(queries)
  return queryResult
}

export const getJobMetricsWithFilter = async(filters, isEmployeeLevel) => {
  const jobCategory = []
  const defaultEmployeeSelection = 'all-employees'
  const workers = filters?.allUsers
  let fromDate = filters?.startDate
  let toDate = filters?.endDate
  if (filters?.dataEntry) {
    jobCategory.push(dataEntryUser)
  }

  if (filters?.verification) {
    jobCategory.push(verificationUser)
  }

  const args = []
  let arrIndex = 0
  args[arrIndex] = collection(firestore, metricsCollectionName)

  // filter the keystores entries
  args[++arrIndex] = where('activityType', '==', 'keystroke')

  // filter by job category
  if (jobCategory.length > 0) {
    if (jobCategory.length === 1) {
      args[++arrIndex] = where('jobCategory', '==', jobCategory[0])
    }
  }
 
  // filter by country
  if (filters?.country && filters?.country !== defaultSelect) {
    args[++arrIndex] = where('workerCountry', '==', filters?.country)
  } 

  // filter by districts
  if (filters?.districtId?.length > 0) {
    const validDistrictId = []
    filters?.districtId.forEach((singleDistrictId, index) => {
      const splittedSingleDistrictId = singleDistrictId.split('-')
      if (splittedSingleDistrictId[1] !== 'ALL') {
        validDistrictId.push(singleDistrictId)
      }
    })
    args[++arrIndex] = where('districtId', 'in', validDistrictId)
  }

  // filter by date
  if (fromDate) {
    // setting start time of the date.
    fromDate = new Date(`${fromDate} 00:00:00`)
    args[++arrIndex] = where('createdTs', '>=', fromDate)
  } 

  if (toDate) {
    // setting end time of the date.
    toDate = new Date(`${toDate} 23:59:59`)
    args[++arrIndex] = where('createdTs', '<=', toDate)
  }

  // filter by workers / customer
  if (isEmployeeLevel) {
    if (workers && workers !== defaultEmployeeSelection) {
      args[++arrIndex] = where('workerId', '==', workers)
    }
  } else {
    if (filters?.accountLevel1) {
      args[++arrIndex] = where('accountLevel1', '==', filters?.accountLevel1.toUpperCase())
    }
  }

  const queries = query.apply(null, args)
  const queryResult = getDocs(queries)
  return queryResult
}
